<template>
  <v-card flat class="sub-site-wrapper">
    <div v-if="whatsAppMessagesStats" class="table-statistics-wrapper">
      <v-row>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Gesamtzahl der Nachrichten:</h5>
            <h3>{{ whatsAppMessagesStats[0].totalMessages }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Nachrichtenanzahl der letzten 24 Stunden:</h5>
            <h3>{{ whatsAppMessagesStats[0].messagesLast24Hours }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Nachrichtenanzahl der letzten 7 Tagen:</h5>
            <h3>{{ whatsAppMessagesStats[0].messagesLast7Days }}</h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Nachrichtenanzahl der letzten 30 Tagen:</h5>
            <h3>{{ whatsAppMessagesStats[0].messagesLast30Days }}</h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Durchschnittliche Nachrichten pro Lead:</h5>
            <h3>
              {{
                formatNumber(whatsAppMessagesStats[0].averageMessagesPerLead)
              }}
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Median Nachrichten pro Lead:</h5>
            <h3>
              {{ formatNumber(whatsAppMessagesStats[0].medianMessagesPerLead) }}
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Durchschnittliche Nachrichten pro Kampagne:</h5>
            <h3>
              {{
                formatNumber(
                  whatsAppMessagesStats[0].averageMessagesPerCampaign
                )
              }}
            </h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Median Nachrichten pro Kampagne:</h5>
            <h3>
              {{
                formatNumber(whatsAppMessagesStats[0].medianMessagesPerCampaign)
              }}
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Durchschnittliche Nachrichten pro Kunde:</h5>
            <h3>
              {{
                formatNumber(
                  whatsAppMessagesStats[0].averageMessagesPerCustomer
                )
              }}
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Median Nachrichten pro Kunde:</h5>
            <h3>
              {{
                formatNumber(whatsAppMessagesStats[0].medianMessagesPerCustomer)
              }}
            </h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Prozent der Nachrichten im Status read:</h5>
            <h3>
              {{ formatPercentage(whatsAppMessagesStats[0].percentageRead) }}
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Prozent der Nachrichten im Status delivered:</h5>
            <h3>
              {{
                formatPercentage(whatsAppMessagesStats[0].percentageDelivered)
              }}
            </h3>
          </div>
        </v-col>
        <v-col cols="12" sm="3">
          <div
            v-if="whatsAppMessagesStats"
            class="statistics-text-box elevation-3"
          >
            <h5>Prozent der Nachrichten im Status failed:</h5>
            <h3>
              {{ formatPercentage(whatsAppMessagesStats[0].percentageFailed) }}
            </h3>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="statistics-text-box elevation-3">
            <h5>Informationen zu den Statistiken:</h5>
            <p>
              Es fließen nur Agenturen in die Statistik ein, die eine Stripe
              Subscription ID besitzen und mindestens einen Slot haben.
            </p>
            <p>
              Die Statistiken wurden am <b>{{ statisticsAge }}</b> erstellt.
            </p>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  created() {
    this.loadStatistics();
  },
  computed: {
    ...mapState("statistics", [
      "whatsAppMessagesStats",
      "loading",
      "statisticsAge",
    ]),
  },
  methods: {
    ...mapActions("statistics", ["fetchMostRecentStatistic"]),
    async loadStatistics() {
      await this.fetchMostRecentStatistic();
    },
    formatNumber(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return "0";
      }
      return Number(value).toFixed(2);
    },
    formatPercentage(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return "0%";
      }
      return `${Number(value).toFixed(2)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table-statistics-wrapper {
  padding: 24px;
}

.statistics-text-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-weight: 500;
  border: 1px solid rgb(196, 196, 196);
  border-radius: 12px;
  padding: 12px;
}
</style>
